import { render, staticRenderFns } from "./CourierSupplierProfile.vue?vue&type=template&id=6c92cbf8&"
import script from "./CourierSupplierProfile.vue?vue&type=script&lang=js&"
export * from "./CourierSupplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./CourierSupplierProfile.vue?vue&type=style&index=0&id=6c92cbf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports